var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.resume.profilePicture)?_c('v-container',{staticClass:"d-flex flex-column align-center"},[_c('img',{staticClass:"img",attrs:{"src":_vm.getImageUrl()}})]):_c('v-container',{staticClass:"my-0"})}
var staticRenderFns = []

export { render, staticRenderFns }